import { render } from "./detail-pra_pelaksanaan_praktikum.vue?vue&type=template&id=26444d49"
import script from "./detail-pra_pelaksanaan_praktikum.vue?vue&type=script&lang=js"
export * from "./detail-pra_pelaksanaan_praktikum.vue?vue&type=script&lang=js"

import "./detail-pra_pelaksanaan_praktikum.vue?vue&type=style&index=0&id=26444d49&lang=css"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__